import type { ReactNode } from "react";

import type { TenantBranding } from "@/api/types";
import { KshopLogo } from "@/components/brand/KMark";

/**
 * Centered sign-in frame. The top shows the tenant logo (with a tenant hint) or the K-SHOP lockup;
 * the "by Kasten Technologies" byline sits under the form card and links to the company site.
 */
export function AuthFrame({ tenant, children, footer }: { tenant?: TenantBranding | null; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-canvas px-4 py-10">
      <main className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          {tenant ? (
            tenant.logo_url ? (
              <img src={tenant.logo_url} alt={`${tenant.name} logo`} className="max-h-20 max-w-[220px] object-contain" />
            ) : (
              <div className="text-2xl font-semibold text-fg">{tenant.name}</div>
            )
          ) : (
            <KshopLogo subtitle={false} />
          )}
        </div>
        <div className="rounded-lg border border-line bg-surface p-6 shadow-sm">{children}</div>
        {footer && <div className="mt-4 text-center text-sm text-fg-muted">{footer}</div>}
        <p className="mt-4 text-center text-xs text-fg-muted">
          {tenant && <span className="font-semibold text-fg">K-SHOP </span>}
          by{" "}
          <a href="https://kastentechnologies.com" target="_blank" rel="noopener noreferrer" className="font-medium text-accent-text hover:underline">
            Kasten Technologies
          </a>
        </p>
      </main>
    </div>
  );
}
